export default "https://legacy.eskolare-development.com/images/symbol-color.png";